import React, { Component } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { withRouter } from "react-router-dom";

// users
import { logout } from "helpers/authUtils";
import { confirmBox } from "helpers/messageHelper";

class ProfileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState((prevState) => ({
      menu: !prevState.menu,
    }));
  }

  logoutHandler = async () => {
    const response = await confirmBox(
      "Do you want to logout from this system?"
    );
    if (response) {
      logout(this.props.history);
    }
  };

  render() {
    return (
      <React.Fragment>
        <Dropdown
          isOpen={this.state.menu}
          toggle={this.toggle}
          className="notification-list list-inline-item nav-pro-img"
          tag="li"
        >
          <DropdownToggle className="nav-link arrow-none nav-user" tag="a">
            <i
              className="fa fa-user-circle noti-icon"
              style={{ fontSize: 35 }}
            />
          </DropdownToggle>
          <DropdownMenu className="profile-dropdown" right>
            {/* <DropdownItem tag="a" href="#"><i className="mdi mdi-account-circle m-r-5"></i> Profile</DropdownItem>
                        <DropdownItem tag="a" href="#"><i className="mdi mdi-wallet m-r-5"></i> My Wallet</DropdownItem>
                        <DropdownItem tag="a" href="#"><span className="badge mt-1 badge-soft-success float-right">11</span><i className="mdi mdi-settings m-r-5"></i> Settings</DropdownItem>
                        <DropdownItem tag="a" href="#"><i className="mdi mdi-lock-open-outline m-r-5"></i> Lock screen</DropdownItem>
                        <div className="dropdown-divider"></div> */}
            <DropdownItem
              tag="button"
              className="text-danger"
              onClick={this.logoutHandler}
            >
              <i className="mdi mdi-power text-danger"></i> Logout
            </DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    );
  }
}

export default withRouter(ProfileMenu);
